/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1TechnicalproductiontypesQueryResponse } from '../../types/GetV1Technicalproductiontypes.ts'

export const getV1TechnicalproductiontypesQueryKey = () =>
    [{ url: '/v1/TechnicalProductionTypes' }] as const

export type GetV1TechnicalproductiontypesQueryKey = ReturnType<
    typeof getV1TechnicalproductiontypesQueryKey
>

/**
 * {@link /v1/TechnicalProductionTypes}
 */
export async function getV1Technicalproductiontypes(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1TechnicalproductiontypesQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/TechnicalProductionTypes`, ...requestConfig })
    return res
}

export function getV1TechnicalproductiontypesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1TechnicalproductiontypesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1TechnicalproductiontypesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1TechnicalproductiontypesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Technicalproductiontypes(config)
        },
    })
}

/**
 * {@link /v1/TechnicalProductionTypes}
 */
export function useGetV1Technicalproductiontypes<
    TData = ResponseConfig<GetV1TechnicalproductiontypesQueryResponse>,
    TQueryData = ResponseConfig<GetV1TechnicalproductiontypesQueryResponse>,
    TQueryKey extends QueryKey = GetV1TechnicalproductiontypesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1TechnicalproductiontypesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1TechnicalproductiontypesQueryKey()

    const query = useQuery(
        {
            ...getV1TechnicalproductiontypesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
